import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CacheDataService {
  // Private variables to store data
  private _blueprints: any[] = [];

  // Subjects to emit updates when data changes
  blueprintsSubject = new BehaviorSubject<any[]>(undefined);
  //Initial value emitted from this subject will be undefined so that we do not unsubscribe

  public vcsAccountDetails: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(
    [],
  );

  blueprintsLoaded: boolean = false;
  constructor() {}

  // Setter methods to update the private variables and emit the changes
  setBlueprints(blueprints: any[]): void {
    this._blueprints = blueprints;
    this.blueprintsSubject.next(blueprints);
    this.blueprintsLoaded = true;
  }

  // Getters to retrieve the current data
  async getBlueprints(): Promise<any[] | null> {
    if (this.blueprintsLoaded) {
      return this._blueprints; //Once bp is loaded it will be either [] or some array
    }

    // If not, subscribe to the BehaviorSubject to get the data when it's emitted
    return new Promise((resolve) => {
      const subscription = this.blueprintsSubject.subscribe((data) => {
        if (data) {
          resolve(data);
          subscription?.unsubscribe(); // Unsubscribe after receiving the data
        }
      });
    });
  }

  setVcsAccountDetails(accountDetails: any[]) {
    this.vcsAccountDetails.next(accountDetails);
  }

  getVcsAccountDetails() {
    return this.vcsAccountDetails;
  }
}
